import React from 'react'
import { connect } from 'react-redux'
import { Redux, WebClient, constants, UpDown, getUserData } from '../../../components'
import { FormattedMessage, injectIntl } from 'react-intl'
import classNames from 'classnames'
import { FlatList } from 'react-native'
import moment from 'moment'
import CouponNumpad from './components/coupon-numpad'
import _ from "lodash"

let listener_initialized = false

class Coupon extends React.Component {

    static defaultProps = {
        hideClose: false
    }

    constructor(props) {
        super(props)
        this.wc = new WebClient();
        this.state = {
            showCouponTypeModal: false,
            activeAmountTrigger: 1,
            betAmount: 1,
            selectedCombine: 0,
            selectedCombinations: [],
            tempSelectedCombinations: [],
            showCouponNumpad: false
        }
    }

    componentDidMount() {

    }

    _checkPrinterStatus() {

        if (window?.ipcRenderer && !listener_initialized) {
            window.ipcRenderer.on('printerStatusResponse', (event, args) => {
                // console.log("PRINTER STATUS RESPONSE", args)
            }); 
            listener_initialized = true
        }        

        if (window?.ipcRenderer) {
            window.ipcRenderer.send("printerStatusRequest", "_")
        }       
    }

    resetTrigger() {
        Redux.updateCouponBottom({bet_trigger: 1, bet_amount: 1})
    }

    addAmount(a) {
        let b = this.props.coupon_bottom.bet_amount + a
        if (b > this.props.member.userCredit) b = parseFloat(this.props.member.userCredit)
        Redux.updateCouponBottom({bet_amount: b})
    }

    _openCouponTypes() {
        let a = this.props.combinations.filter(x => x.selected == true)
        this.setState({showCouponTypeModal: true, selectedCombinations: a})
    }

    addOrRemoveCombination(item) {
        
        let a = [...this.state.selectedCombinations]
        let j = a.indexOf(item)
        
        if (j != -1) {
            a.splice(j, 1)
        } else {
            a.push(item)
        }
        
        this.setState({selectedCombinations: a})
    }    

    confirmCombinations() {
        Redux.addOrRemoveSelectedCombination(this.state.selectedCombinations, this.props.intl)
        this.setState({showCouponTypeModal: false})
    }

    _setBanko(is_selected, item, index) {
        const { coupon, intl } = this.props

        let mbc = coupon.length - 2;
        let bc = coupon.filter(x => x?.is_banko === true)?.length ?? 0

        if (bc < mbc || is_selected) {
            Redux.setOddBanko(index, intl)
        }

    }  

    getSystemText() {
        let z = this.props.combinations.filter(x => x.selected == true)
        let a = []
        let b = _.orderBy(z, ['combine'],['asc']);
        b.forEach((e) => {
            a.push(e.combine)
        })
        return a.join(" + ")
    }

    _createCoupon() {

        const { coupon, coupon_bottom, combinations } = this.props

        let ticket_type = coupon_bottom.type
        let tips = []

        coupon.forEach((e) => {
            e.odd.forEach((o) => {
                tips.push({
                    banko: e?.is_banko ? 1 : 0,
                    oddTypeId: o.oddsType,
                    ttype: o.ttype,
                    mtip: 1,
                    sid: o.sportId,
                    mid: e.matchid,
                    team1: e.item.homeTeam,
                    team2: e.item.awayTeam,
                    mDate: moment(e.item.matchDate).format('YYYY-MM-DD HH:mm:ss'),
                    oddTypeStatus: o?.oddtypestatus ?? o.status,
                    outComeStatus: o?.outComeStatus ?? o.status,
                    lock: 1,
                    betstts: "not_started",
                    catId: o.categoryId,
                    tourId: o.tournamentId,    
                    ktip: {
                        betTotal: 5000,
                        kombiMaxPay: o.kombiMaxPay,
                        kombiMaxStake: o.kombiMaxStake,
                        kombiMinStake: o.kombiMinStake,
                        liveMaxPay: o.kombiMaxPay,
                        liveMaxStake: o.kombiMaxStake,
                        liveMinStake: o.kombiMinStake,
                        oddsType: o.oddsType,
                        ttype: o.ttype,
                        sportId: o.sportId,
                        categoryId: o.categoryId,
                        tournamentId: o.tournamentId,
                        matchId: o.matchId,
                        special: o.special,
                        onSystemOdd: o.onSystemOdd,
                        minTip: o.minTip,
                        odds: o.odds.toString(),
                        outCome: o.outCome,
                        outComeId: o.outComeId,
                        outcomeid: o.outComeId,
                        singleMaxPay: o.singleMaxPay,
                        singleMaxStake: o.singleMaxStake,
                        singleMinStake: o.singleMinStake,
                        slcted: 1,
                        oddid: o.oddsType,
                        active: o.status
                      }                     
                })
            })

        })

        let systemTickets = []

        if (coupon_bottom.type == "SK") {
            systemTickets = combinations.filter(a => a.selected === true).reduce((a, o) => (a.push(o.combine), a), [])
        }
        

        let d = {
            ticketStake: coupon_bottom.bet_amount.toFixed(2).toString(),
            totalStake: (coupon_bottom.bet_amount * coupon_bottom.coupon_number).toFixed(2).toString(),
            ticketType: ticket_type,
            couponType: ticket_type == "KK" || ticket_type == "TK" ? 0 : 2,
            systemTickets,
            oddChangeOk: 1,
            tips
        }

        // console.log("coupon data", d)
        // console.log("coupon data", JSON.stringify(d))

        this.wc.post(constants.uris.crcp, d, 
        {
            setLang: true,
            setOperatorId: true,
            setUserId: true,
            setServerId: true,
            setToken: true
        }).then((response) => {
            if (response.status) {
                Redux.showToast("success", response.msg)
                getUserData(2, this.props.member.userId)

                Redux.emptyCoupon()
                this.props.onClose()

                let ticketId = response.ticketId
                this._sendCouponToPrint(ticketId)
            }
        })
    }

    _sendCouponToPrint(id) {

        if (window?.ipcRenderer) {
            let url = constants.prints.couponprint.replace("{{couponId}}", id).replace("{{lang}}", this.props.language)

            // console.log("url -->", url)
            /* PRINT COUPON */
            window.ipcRenderer.send("printUrl", {
                url,
                filename: `ticket_coupon_${id}`,
                type: 'ticket',
                couponId: id
            })
            /* PRINT COUPON */
        }

    }

    _reset() {
        this.setState({selectedCombinations: [], tempSelectedCombinations: []})
    }

    _setActiveTrigger(i) {
        Redux.updateCouponBottom({bet_trigger: i})
    }

    render() {
        const { showCouponTypeModal, selectedCombinations, showCouponNumpad } = this.state
        const { intl, coupon_settings, coupon, hideClose, coupon_bottom, combinations, selected_combinations } = this.props
        
        const cl = coupon.length
        let disabled = Boolean(cl == 0)

        return (
        <div className="coupon-cont">
            {
            !hideClose && (
                <button onClick={() => { this.props.onClose() }} className="close-coupon"><FormattedMessage id="close" /></button>
            )
            }

            <div className={classNames({"coupon-title": Boolean(coupon.length > 0), "coupon-title-detail": Boolean(coupon.length == 0)})}>

                {
                coupon.length > 0 && (
                <>
                <FormattedMessage id={Redux.getCouponTypeName(coupon_bottom.type)} /> 

                <font style={{marginLeft: 5}}>({coupon_bottom.odd_count})</font>
                
                <span onClick={() => { this._reset(); Redux.emptyCoupon() }}><i className="fas fa-times" /></span>
                </>
                )
                }

                {
                coupon.length == 0 && (
                    <FormattedMessage id="betting_coupon" /> 
                )
                }

            </div>

            <div className={classNames({"coupon-middle": !hideClose, "coupon-middle-2": hideClose})}>

                {
                (coupon.length == 0) && (
                    <span className="empty-coupon"><FormattedMessage id="empty_coupon" /></span>
                )
                }

                {
                (coupon.length > 0) && (
                <FlatList
                    data={coupon}
                    style={{ width: "100%", height: "100%" }}
                    showsVerticalScrollIndicator={false}
                    showsHorizontalScrollIndicator={false}
                    renderItem={(row) => {
                        const { item, odd, unique, matchid } = row.item
                        
                        return (
                            <div key={row.index} className="coupon-item-cont">
                                <div className="coupon-item-left">
                                    <div className="coupon-item-sportname">{item.sportName} - {item.tournamentName}</div>
                                    <div className="coupon-item-sportname">{moment(item.matchDate).format("DD/MM HH:mm")}</div>
                                    <div className="coupon-item-teams">
                                        <span>{item.homeTeam} - {item.awayTeam}</span>
                                    </div>
                                    {
                                    odd.map((o, yindex) => {
                                        return (
                                        <div key={o.unique} className="coupon-item-odd">
                                            <span>{o.typeName} - {o.outCome}</span>
                                            <div className="flex flex-row items-center">
                                            <span>{o.odds.toFixed(2)}</span>
                                            <div onClick={() => { this._reset(); Redux.addOrRemoveOdd(item, o, intl) }} className="ml-2 text-md"><i className="fas fa-times text-red-600" /></div>
                                            </div>
                                        </div>
                                        )
                                    })
                                    }
                                </div>
                                <div className="coupon-item-right">
                                    <div onClick={() => { this._reset(); Redux.removeMatchFromCoupon(item, odd, intl) }} className="coupon-item-delete"><i className="fas fa-times" /></div>
                                    {
                                    (coupon_settings.is_system_coupon_active && (combinations.filter(x => x.selected).length > 0)) && (

                                        <div onClick={() => { this._setBanko(Boolean(row?.item?.is_banko), row.item, row.index) }} className={classNames({
                                            'coupon-item-banko': true,
                                            'selected': Boolean(row?.item?.is_banko)
                                        })}>B</div>

                                    ) 
                                    }
                                </div>
                            </div>
                        )
                    }}
                />
                )
                }

            </div>
            
            {
            coupon.length > 0 && (
            <>
            <UpDown mb="mb-0" upClick={() => {  }} downClick={() => {  }} />
            <div className="coupon-bottom">

                {
                (coupon_bottom.type == "CK" || coupon_bottom.type == "TK") ? 
                <div className="coupon-type">
                    <FormattedMessage id={Redux.getCouponTypeName(coupon_bottom.type)} />
                </div>            
                :
                <div onClick={() => { this._openCouponTypes() }} className="coupon-type">

                    {
                    (coupon_bottom.type == "TK") && (
                        <FormattedMessage id="single_coupon" />
                    )
                    }

                    {
                    (coupon_bottom.type == "KK" && coupon.length > 1) && (
                        <FormattedMessage id="combine_coupon" values={{count: coupon.length}} />
                    )
                    }

                    {
                    (coupon_bottom.type == "SK") && (
                        <FormattedMessage id="system_coupon" values={{p1: this.getSystemText(), p2: coupon.length, p3: coupon_bottom.coupon_number}} />
                    )
                    }

                    
                </div>            
                }

                <div className="amounts">
                    <span onClick={() => { this.resetTrigger() }}>C</span>
                    <span 
                    onClick={() => { this.addAmount(1) }}
                    className={classNames({
                    'active': false
                    })}>1</span>
                    <span 
                    onClick={() => { this.addAmount(5) }}
                    className={classNames({
                    'active': false
                    })}>5</span>
                    <span 
                    onClick={() => { this.addAmount(10) }}
                    className={classNames({
                    'active': false
                    })}>10</span>
                    <span 
                    onClick={() => { this.addAmount(20) }}
                    className={classNames({
                    'active': false
                    })}>20</span>
                    <span 
                    onClick={() => { this.addAmount(50) }}
                    className={classNames({
                    'active': false
                    })}>50</span>
                    <span 
                    onClick={() => { this.setState({showCouponNumpad: true}) }}
                    className={classNames({
                    'active': false
                    })}>...</span>                    
                </div>

                <div className="bottom-row">
                    <span className="text-lg font-bold font-roboto"><FormattedMessage id="bet_amount" /></span>
                    <span className="text-lg font-bold font-roboto">{coupon_bottom.bet_amount.toFixed(2)}</span>
                </div>

                <div className="bottom-row">
                    <span><FormattedMessage id="total_stake" /></span>
                    {
                    coupon_bottom.coupon_number <= 1 ?
                    <span>{coupon_bottom.bet_amount.toFixed(2)}</span>
                    :
                    <span>{coupon_bottom.coupon_number} x {coupon_bottom.bet_amount.toFixed(2)} = {(coupon_bottom.bet_amount * coupon_bottom.coupon_number).toFixed(2)}</span>
                    }
                </div>

                <div className="bottom-row">
                    <span><FormattedMessage id="coupon_number" /></span>
                    <span>{coupon_bottom.coupon_number}</span>
                </div>

                <div className="bottom-row">
                    <span><FormattedMessage id="total_odds" /></span>
                    <span>{coupon_bottom.total_rate.toFixed(2)}</span>
                </div>

                <div className="bottom-row">
                    <span><FormattedMessage id="max_gain" /></span>
                    <span>{(coupon_bottom.total_rate * coupon_bottom.bet_amount).toFixed(2)}</span>
                </div>

                <div className="bottom-row">
                    <span><FormattedMessage id="total" /></span>
                    <span>{(coupon_bottom.total_rate * coupon_bottom.bet_amount).toFixed(2)}</span>
                </div>                        

                <div className="odd-changes-check">
                    <div className="checkbox"><i className="fas fa-check" /></div>
                    <span><FormattedMessage id="i_accept_rate_changes" /></span>
                </div>

                <button onClick={() => { this._createCoupon() /*this._checkPrinterStatus()*/ }} disabled={disabled} className="create-coupon"><FormattedMessage id="create_coupon" /></button>
                
            </div>            
            </>
            )
            }
            
            {
            showCouponTypeModal && (
            <div className="coupon-types-cont">

                {
                combinations.map((item, index) => {
                    
                    const cselected = Boolean(selectedCombinations.indexOf(item) != -1)
                    if (item.combine <= Redux.getBankoCount()) return null

                    return (
                        <div key={index} 
                        onClick={() => { this.addOrRemoveCombination(item) }}
                        className={classNames({
                            'combination-item': true,
                            'selected': cselected
                        })}>
                            <span>{item.label}</span>
                            <span>{item.coupon_count}</span>
                        </div>        
                    )
                })
                }
                
                <button onClick={() => { this.confirmCombinations() }} className="confirm-coupon-types"><FormattedMessage id="confirm" /></button>
                <button onClick={() => { this.setState({showCouponTypeModal: false}) }} className="close-coupon-types"><FormattedMessage id="cancel" /></button>
            </div>
            )
            }

            {
            showCouponNumpad && (
            <div className="coupon-numpad-cont">
                <CouponNumpad onClose={() => { this.setState({showCouponNumpad: false}) }} keyword={coupon_bottom.bet_amount.toFixed(2)} />
            </div>
            )
            }

        </div>
        );
    }
}

const msp = (state) => {
  return {
      config: state.config,
      coupon_settings: state.coupon_settings,
      coupon: state.coupon,
      settings: state.settings,
      member: state.member,
      language: state.language,
      coupon_bottom: state.coupon_bottom,
      combinations: state.combinations,
      selected_combinations: state.selected_combinations
  }
}

export default connect(msp)(injectIntl(Coupon))
